import { Injectable } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase';
import { Observable } from 'rxjs';
import { DadosService } from './services/dados.service';




@Injectable({
  providedIn: 'root'
})
export class AuthService {

  email: string = "";
  idusuario: string = "";
  logado = false;
  dados;

  public user: Observable<firebase.User>;

  constructor(public afAuth: AngularFireAuth, private dadosService:DadosService) {

    this.user = afAuth.authState;

    this.user.subscribe(u => {
      if (u) {
        this.logado = true;
        this.email = u.email;
        this.idusuario = u.uid;       
        let temp = this.dadosService.getByField('uid', u.uid).valueChanges().subscribe(obj => {
          this.dados = obj[0];
          temp.unsubscribe();
        }); 
      }

    });

  }

  criarUsuario(newEmail: string, newPassword: string): Promise<any> {
    return this.afAuth.auth.createUserWithEmailAndPassword(newEmail, newPassword)
      .then(response => response)
      .catch(erro => erro);
  }

  enviaRecuperacaoSenha(email) {
    this.afAuth.auth.sendPasswordResetEmail(email);
  }

  loginPorEmail(email: string, senha: string): Promise<any> {
    return this.afAuth.auth.signInWithEmailAndPassword(email, senha);
  }

  login() {
    this.afAuth.auth.signInWithPopup(new firebase.auth.GoogleAuthProvider()).then(() => this.logado = true);
  }

  logout() {
    this.afAuth.auth.signOut().then(() => this.logado = false);
  }

  isAdm() {
    return this.dados !== undefined && this.dados["isAdm"];
  }

  isVendedor() {
    return this.dados !== undefined && this.dados["isVendedor"];
  }

  isLiberado(){
    return this.dados !== undefined && this.dados["liberado"];    
  }

}
